(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["birrot-newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('birrot-newsletter')) return;

    class BirrotNewsletter extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('#birrot-newsletter-bar');
        this.panel = this.querySelector('#birrot-newsletter-panel');

        // Signed up in this browser (the inline script's class): the
        // stylesheet hides the bar; the element stays so the Newsletter
        // link below can show it again. The theme editor previews the
        // page, not a visitor: it always shows the bar.
        const posted = this.panel.hasAttribute('data-open-on-load');
        if (window.Shopify?.designMode) this.show();

        this.bar.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-birrot-newsletter-close]').forEach((el) => {
          el.addEventListener('click', () => this.panel.close());
        });
        this.panel.addEventListener('close', () => this.closed());
        this.onKeydown = (event) => {
          if (event.key === 'Escape' && this.panel.open) this.panel.close();
        };
        document.addEventListener('keydown', this.onKeydown);
        // A link to #newsletter on this page (the footer's Newsletter item)
        // opens the panel, bringing the bar back first in a browser that
        // has signed up; one on another page navigates here (below).
        this.onLinkClick = (event) => {
          const link = event.target.closest('a');
          if (!(link instanceof HTMLAnchorElement) || link.hash !== '#newsletter') return;
          if (link.pathname !== location.pathname) return;
          if (event.defaultPrevented || event.button !== 0) return;
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.show();
          this.open();
        };
        document.addEventListener('click', this.onLinkClick);

        // Back from a post: show the success or error line, and remember a success.
        if (posted) {
          this.open();
          if (this.panel.hasAttribute('data-signed-up')) this.remember();
        } else if (location.hash === '#newsletter') {
          // Sent here by a Newsletter link elsewhere: open, and drop the
          // hash so a reload does not open it again.
          this.open();
          history.replaceState(null, '', location.pathname + location.search);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onLinkClick);
      }

      remember() {
        try {
          localStorage.setItem('birrot-newsletter-signed-up', String(Date.now()));
        } catch (e) {
          /* storage blocked: the bar comes back next time */
        }
      }

      // The bar back on the page in a browser that has signed up, for this
      // load: the inline script's class goes, and with it the hide and
      // the dropped page padding.
      show() {
        document.documentElement.classList.remove('birrot-newsletter-signed-up');
      }

      open() {
        if (this.panel.open) return;
        this.panel.show();
        // Focus the dialog itself: opening one focuses its first control, and
        // Safari draws :focus-visible on it (CLAUDE.md).
        this.panel.focus({ preventScroll: true });
        this.classList.add('birrot-newsletter--open');
        this.bar.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('birrot-newsletter-open');
      }

      // After a signup the bar goes with the panel, as it does on the next
      // load; focus is left where the dialog returns it.
      closed() {
        this.classList.remove('birrot-newsletter--open');
        this.bar.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('birrot-newsletter-open');
        if (this.panel.hasAttribute('data-signed-up')) {
          document.documentElement.classList.add('birrot-newsletter-signed-up');
          return;
        }
        this.bar.focus({ preventScroll: true });
      }
    }

    customElements.define('birrot-newsletter', BirrotNewsletter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["birrot-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('birrot-slideshow')) return;

    /*
     * theme.js initContentSlider: translateX between full-width slides,
     * autoplay that reverses at either end, and the header colours of the
     * slide on screen, dispatched as `birrot:slide-change` (bubbling, with
     * the slide's colours) for sections/birrot-header.liquid to apply. No
     * autoplay under prefers-reduced-motion (production has no such check).
     *
     * A slide whose text colour is Automatic (`data-ink="auto"`) takes black
     * or white for its button and the header from its photo
     * (assets/birrot-ink.js, docs/plans/completed/AUTO-INK.md): the slide on screen
     * first, then the one autoplay goes to next, each again when the hero's
     * size or the mobile image changes. Its Manual colours are the first
     * paint and stay if the photo cannot be read.
     */
    const HEADER_INK = [
      ['menu', '.birrot-header__menu-button'],
      ['nav', '.birrot-header__actions'],
    ];
    let inkModule = null;

    class BirrotSlideshow extends HTMLElement {
      connectedCallback() {
        this.canvas = this.querySelector('.birrot-slideshow__canvas');
        this.slides = [...this.querySelectorAll('.birrot-slideshow__slide')];
        this.speed = Number(this.dataset.transitionSpeed) || 0.8;
        this.position = 0;
        this.direction = 1;
        /** The latest sample per slide, by image URL and hero size. @type {Map<HTMLElement, { key: string, done: Promise<void> }>} */
        this.inks = new Map();
        // No copy is requested before the first slide's own image is in, so
        // sampling never competes with it.
        this.firstImage = imageLoaded(this.slides[0]?.querySelector('picture img'));
        this.show(0, false);

        if (this.slides.some((slide) => slide.dataset.ink === 'auto')) {
          this.resizeObserver = new ResizeObserver(() => {
            clearTimeout(this.resampling);
            this.resampling = setTimeout(() => this.inkAround(this.position), 150);
          });
          this.resizeObserver.observe(this);
        }

        const interval = Number(this.dataset.autoplaySpeed) * 1000;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && this.slides.length > 1 && interval > 0 && !reduced) {
          this.timer = setInterval(() => this.advance(), interval);
        }
      }

      disconnectedCallback() {
        this.stop();
        this.resizeObserver?.disconnect();
        clearTimeout(this.resampling);
      }

      stop() {
        clearInterval(this.timer);
        clearTimeout(this.settling);
        this.timer = null;
        this.settling = null;
      }

      /* Test-only: the harness (tests/lib/themes/horizon.js, holdSlideshow)
         calls this before every capture of a page with the hero, to stop on
         slide 1 with no transition, and then waits for `inked`. Reduced-motion
         emulation would stop the timer only if set before load, and would not
         bring back a slide that has already moved; no storefront code calls
         it. `inked` settles once slide 1 has its ink or has kept its own
         colours (the sample show() started, from the cache). */
      hold() {
        this.stop();
        this.show(0, false);
        this.inked = this.ink(this.slides[0]);
      }

      /** Where autoplay goes from here, turning at either end. */
      nextIndex() {
        const next = this.position + this.direction;
        return next < 0 || next >= this.slides.length ? this.position - this.direction : next;
      }

      advance() {
        const next = this.nextIndex();
        this.direction = next - this.position;
        this.show(next, true);
      }

      show(index, animate) {
        this.position = index;
        this.canvas.style.transition = animate ? `transform ${this.speed}s cubic-bezier(0.25, 1, 0.5, 1)` : 'none';
        this.canvas.style.transform = `translateX(${-index * 100}%)`;
        clearTimeout(this.settling);
        this.settling = null;
        // Production recolours the header once the slide has arrived.
        if (animate) {
          this.settling = setTimeout(() => {
            this.settling = null;
            this.announce();
          }, this.speed * 1000);
        } else {
          this.announce();
        }
        this.inkAround(index);
      }

      announce() {
        const slide = this.slides[this.position];
        if (!slide) return;
        const { inkMenu, inkNav, menuColor, navColor } = slide.dataset;
        this.dispatchEvent(
          new CustomEvent('birrot:slide-change', {
            bubbles: true,
            detail: { menuColor: inkMenu || menuColor, navColor: inkNav || navColor },
          })
        );
      }

      /** The slide at `index`, then the one after it, one copy at a time. */
      inkAround(index) {
        const current = this.ink(this.slides[index]);
        current.then(() => this.ink(this.slides[this.nextIndex()]));
        return current;
      }

      /**
       * Samples `slide` unless it was sampled for the same image at the same
       * size. Never rejects.
       * @param {HTMLElement | undefined} slide
       */
      ink(slide) {
        if (!slide || slide.dataset.ink !== 'auto') return Promise.resolve();
        const src = imageSource(slide);
        const { width, height } = this.getBoundingClientRect();
        if (!src || !width || !height) return Promise.resolve();
        const key = `${src} ${width}x${height}`;
        const latest = this.inks.get(slide);
        if (latest?.key === key) return latest.done;

        const done = this.sample(slide, src, key).catch(() => {
          // A copy that cannot be loaded or read leaves the Manual colours,
          // and the next resize tries again.
          if (this.inks.get(slide)?.key === key) this.inks.delete(slide);
        });
        this.inks.set(slide, { key, done });
        return done;
      }

      /** @param {HTMLElement} slide @param {string} src @param {string} key */
      async sample(slide, src, key) {
        await this.firstImage;
        // A failed import is tried again by the next sample, not remembered.
        inkModule ??= import(this.dataset.inkModule).catch((error) => {
          inkModule = null;
          throw error;
        });
        const { inkOver } = await inkModule;

        // Measured after the waits, against the layout the copy will meet.
        const host = this.getBoundingClientRect();
        const boxes = {};
        const label = slide.querySelector('.birrot-slideshow__button')?.getBoundingClientRect();
        if (label?.width) boxes.button = relativeTo(label, slide.getBoundingClientRect());
        // The header is fixed and transparent only over the top of the page,
        // where the hero starts: its box is taken as at scroll 0, so a page
        // reloaded part-way down still samples the photo under the header.
        for (const [name, selector] of HEADER_INK) {
          const rect = document.querySelector(selector)?.getBoundingClientRect();
          if (rect?.width && rect.top < host.height) boxes[name] = relativeTo(rect, { left: host.left, top: 0 });
        }

        const ink = await inkOver(src, host, boxes);
        // A newer sample (another size, or the other image across 767px)
        // has started since: this one is out of date.
        if (this.inks.get(slide)?.key !== key) return;
        const buttons = slide.querySelector('.birrot-slideshow__buttons');
        if (buttons && ink.button) buttons.style.color = ink.button;
        if (ink.menu) slide.dataset.inkMenu = ink.menu;
        if (ink.nav) slide.dataset.inkNav = ink.nav;
        if (slide === this.slides[this.position] && !this.settling) this.announce();
      }
    }

    /** The URL the slide's <picture> shows at this width: the mobile <source> or the <img>. */
    function imageSource(slide) {
      const source = slide.querySelector('picture source');
      if (source?.media && window.matchMedia(source.media).matches) return source.srcset.trim().split(/\s+/)[0] || null;
      return slide.querySelector('picture img')?.getAttribute('src') || null;
    }

    /** Resolves when the image has loaded or failed; at once without one. */
    function imageLoaded(image) {
      if (!image || image.complete) return Promise.resolve();
      return new Promise((resolve) => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      });
    }

    function relativeTo(rect, origin) {
      return { left: rect.left - origin.left, top: rect.top - origin.top, width: rect.width, height: rect.height };
    }

    customElements.define('birrot-slideshow', BirrotSlideshow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["birrot-suppliers"] && !Shopify.designMode) return;
  try {
    
  // theme.js `.sup-nav a` click handler on Showcase: mark the tab active,
  // retitle the list and show the stores filed under that region.
  if (!customElements.get('birrot-suppliers')) {
    customElements.define(
      'birrot-suppliers',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const tab = event.target.closest('[data-birrot-region]');
            if (!tab) return;
            const region = tab.dataset.birrotRegion;
            this.querySelectorAll('[data-birrot-region]').forEach((button) => {
              const active = button === tab;
              button.classList.toggle('is-active', active);
              button.setAttribute('aria-pressed', String(active));
            });
            this.querySelector('[data-birrot-region-title]').textContent = tab.textContent;
            this.querySelectorAll('[data-birrot-store-region]').forEach((store) => {
              store.hidden = !store.dataset.birrotStoreRegion.split('|').includes(region);
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
